import { 
  ADD_EXERCISE, 
  FETCH_TRAINER_EXERCISES, 
  FETCH_CORPORATE_EXERCISES, 
  EDIT_EXERCISE, 
  FETCH_FAVOURITE_EXERCISES,
  RESET_EXERCISES_LISTING, 
  SET_EXCERCISE_FILTER,
  SET_EXERCISE_SEARCH_TERM,
  RESET_EXERCISE_FILTER,
  UPDATE_EXERCISES_FAVOURITE
} from "../actionTypes"

const initialState = {
  trainer: [],
  corporate: [],
  favourite: [],
  filter: {
    library: 'trainerExercises',
    equipmentId: 0,
    categoryId: 0,
    blockCategoryId: 0
  },
  isLoadMore: false,
  searchTerm: ''
};

export default (state = initialState, action=null) => {
  let { type, user, payload } = action;
  switch(type) {
    case ADD_EXERCISE:
    case EDIT_EXERCISE:
      return {
        ...state,
        [user]: { ...state[user], ...payload }
      }
    case FETCH_TRAINER_EXERCISES:
      let exercises = [];
      if (Object.values(state.trainer).length > 0) {
        exercises = Object.values(state.trainer)
        exercises = [...exercises, ...payload]
      } else {
        exercises = payload
      }
      return {
        ...state,
        trainer:  {
          ...exercises
        },
        isLoadMore: payload.length === 0 ? false : true
      }
    case FETCH_FAVOURITE_EXERCISES:
        let favExercises = [];
       if (Object.values(state.favourite).length > 0) {
          favExercises = Object.values(state.favourite)
          favExercises = [...favExercises, ...payload]
        } else {
          favExercises = payload
        }
        return {
          ...state,
          favourite:  {
            ...favExercises
          },
          isLoadMore: payload.length === 0 ? false : true
        }
    case UPDATE_EXERCISES_FAVOURITE: 
      let { isFavourite, exerciseId, library, userId, favouriteByUsers } = payload;
      let key;
      if (library === 'trainerExercises') {
          key = 'trainer';
      }
      if (library === 'corporateExercises') {
        key = 'corporate';
      }
      if (library === 'favExercises') {
        key = 'favourite'
      }
      let items = Object.values(state[key]);
      const findItemIndex = items.findIndex((d) => d._id === exerciseId);
      if (findItemIndex > -1) {
          if (key === 'favourite') {
            items.splice(findItemIndex, 1)
          } else {
            const item = items[findItemIndex];
            const findUserIndex = favouriteByUsers.findIndex((d) => d.userId === userId); 
            if (isFavourite) {
              if (findUserIndex < 0) {
                favouriteByUsers.push(({
                  userId: userId
                }))
                items[findItemIndex]['favouriteByUsers'] = favouriteByUsers;
              }
            } else {
              if (findUserIndex > -1 ) {
                favouriteByUsers.splice(findUserIndex, 1)
                items[findItemIndex]['favouriteByUsers'] = favouriteByUsers;
              }
            }
        }
      }
      return {
        ...state,
        [key]: {
          ...items
        }
      }
    case FETCH_CORPORATE_EXERCISES:
      let corExercises = [];
      if (Object.values(state.corporate).length > 0) {
        corExercises = Object.values(state.corporate)
        corExercises = [...corExercises, ...payload]
      } else {
        corExercises = payload
      }
      let isLoadMore = false;
      if (payload.length === 0) {
        isLoadMore = true;
      }
      return {
        ...state,
        corporate:  {
          ...corExercises
        },
        isLoadMore: payload.length === 0 ? false : true
      }
    case RESET_EXERCISES_LISTING: 
      return {
        ...state,
        corporate: [],
        trainer: [],
        favourite: [],
        isLoadMore: false
      }
    case SET_EXCERCISE_FILTER: 
      return {
        ...state,
        filter: {
          ...state.filter,
          [payload.key] : payload.value
        }
      }
    case RESET_EXERCISE_FILTER: 
      return {
        ...state,
        filter: {
          library: 'trainerExercises',
          equipmentId: 0,
          categoryId: 0,
          blockCategoryId: 0
        }
      }
    case SET_EXERCISE_SEARCH_TERM:
      return {
        ...state,
        searchTerm: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/exercises.js